import InlineCommentingPopupContainer from './InlineCommentingPopupContainer';

export default InlineCommentingPopupContainer;